import React, {FC} from 'react';
import {useSelector} from 'react-redux';
import {WeatherForecastLocation} from '@/app/interfaces/weather';
import {hourReduce} from '@/common/helpers/unitReducers/hourReduce';
import {getNowDateWidthOffsetToLocal} from '@/common/helpers/date/getNowDateWidthOffsetToLocal';
import {selectUnitTypes} from '@/app/store/config/selectors';
import styles from './WeatherDailyCurrentHour.css';

interface WeatherDailyCurrentHourProps {
	location: WeatherForecastLocation;
	timezoneOffset: number;
}

export const WeatherDailyCurrentHour: FC<WeatherDailyCurrentHourProps> = props => {
	const {location, timezoneOffset} = props;
	const {clockType} = useSelector(selectUnitTypes);
	const nowDate = timezoneOffset !== undefined ? getNowDateWidthOffsetToLocal(timezoneOffset) : new Date();
	// Always show the next hour (business logic)
	const nowHours = nowDate.getHours() === 23 ? 23 : nowDate.getHours() + 1;

	return <div className={styles.root}>{`${location.title}: ${hourReduce(nowHours, clockType)}`}</div>;
};

WeatherDailyCurrentHour.displayName = 'WeatherDailyCurrentHour';
